/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPictochart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 13v6H1v-6zm8 0v6H9v-6zm8 0v6h-6v-6zM5 15H3v2h2zM7 5v6H1V5zm8 0v6H9V5zm8 0v6h-6V5zM5 7H3v2h2zm8 0h-2v2h2zm8 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartPictochart as ChartPictochart };
